import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-line-chart',
	template: `
		<svg width="100%" height="200" viewBox="0 0 300 200">
			<polyline [attr.points]="linePoints" stroke="blue" stroke-width="5" fill="none" />
		</svg>
	`,
	styles: [':host { display: block; }'],
})
export class LineChartComponent {
	@Input() data: { x: number; y: number }[] = [];

	get linePoints(): string {
		return this.data
			.map((d) => `${d.x * 50},${200 - d.y * 4}`) // Scale for visibility
			.join(' ');
	}
}
